module.exports = __webpack_public_path__ + "img/cnc-04-bg-brand-video-overlay.3e4dac98.png";